// eslint-disable-next-line
import './App.less'
import { I18nextProvider } from 'react-i18next'
import i18next from 'i18next'

import configureTrans from 'src/config/configureTrans'
import LangManager from 'src/managers/LangManager'
import GuardRoute from 'src/routes/GuardRoute'

configureTrans(i18next)

function App(): JSX.Element {
  return (
    <I18nextProvider i18n={i18next}>
      <LangManager />
      <GuardRoute />
    </I18nextProvider>
  )
}

export default App
